export { default as OneTimePass } from './data/one-time-pass.mapper';
export { default as OneTimePassService } from './data/one-time-pass.service';
